import SessionExpired from 'utils/session_expired';

export function handleApiError(message, error) {
  if (error?.status === 401) {
    SessionExpired.renewSessionModal(location.href);
  } else {
    if (error?.status !== 422) {
      toastr.error(message || 'Ocorreu um erro, tente novamente.');
    }

    if (!error?.errors) {
      return Rollbar.error(message, error);
    }

    const errors = Object.keys(error.errors);

    if (errors.length) {
      const errorKey = errors[0];
      const errorMsgs = error.errors[errorKey];
      const errorMsg = (errorMsgs.length && errorMsgs[0]) || '';

      Rollbar.error(
        `API response error${errorMsg && `: ${errorKey} ${errorMsg}`}.`,
        {
          status: error.status,
          statusText: error.statusText,
          responseText: error.responseText
        }
      );
    }
  }
}
